import React, { useContext } from "react";
import { QuoteGroupContext } from "../../../providers/RootContextProvider";
import BaseProductForm from "../../Products/BaseProductForm";
import LModal from "../../../../common/components/Modals/LModal/LModal";
import Button from "../../../../common/components/Forms/Button/Button";
import Icon from "../../../../common/components/Icon/Icon";
import ClientDetailsSection from "../../Clients/ClientDetailsSection/ClientDetailsSection";
import styles from "./FamilySettingsModal.module.scss";
import cx from "classnames";
import { createOrSetClientsAPI } from "../../../api/api";
import { IClient } from "../../../../common/interfaces/IClient";

interface IFamilySettingModal {
    isOpen: boolean;
    onClose: () => void;
    onSubmit?: () => void;
}

const FamilySettingModal: React.FC<IFamilySettingModal> = (props) => {
    const { selectors, actions } = useContext(QuoteGroupContext);

    const { isOpen, onSubmit, onClose } = props;
    return (
        <LModal
            Header={() => null}
            calcHeightMode="auto"
            width="ultra-wide"
            isOpen={isOpen}
            onClose={onClose}>
            {() => {
                return (
                    <BaseProductForm
                        clients={selectors.getClients()}
                        compareProducts={[]}
                        settings={[]}
                        onSubmit={async (settings, clients) => {
                            const res = await createOrSetClientsAPI(
                                selectors.getGroupId(),
                                clients
                            );
                            const activeClients = res.clients.filter(
                                (i: IClient) => i.isActive
                            );
                            actions.setClients(activeClients);
                            actions.populateQuoteConfigs(
                                res.quoteGroupCases.map((s) => s.config)
                            );

                            actions.clearQuoteResults();

                            onSubmit && onSubmit();
                            onClose();
                        }}>
                        {({ dirty, isSubmitting }) => {
                            return (
                                <div className={cx("layout-flex-column--centered")}>
                                    <Icon id="SettingsPeople" />
                                    <h2 className="text-primary text-align--center gap-4xl">
                                        Who needs cover?
                                    </h2>
                                    <ClientDetailsSection />
                                    <div
                                        className={cx(
                                            "layout-flex-row--justify-evenly-spaced",
                                            "flex-gap-l",
                                            "gap-pre-xl",
                                            styles["button-wrapper"]
                                        )}>
                                        <Button
                                            component="button"
                                            variant="box"
                                            onClick={onClose}
                                            size="s"
                                            width="fill"
                                            isDisabled={isSubmitting}>
                                            Cancel
                                        </Button>
                                        <Button
                                            component="button"
                                            type="submit"
                                            variant="calltoaction"
                                            size="s"
                                            isDisabled={!dirty}
                                            isSubmitting={isSubmitting}>
                                            Apply Changes
                                        </Button>
                                    </div>
                                </div>
                            );
                        }}
                    </BaseProductForm>
                );
            }}
        </LModal>
    );
};

export default FamilySettingModal;
